import { Medialink, validateAndGetLinkFromMedialink } from '../../../api/medialink';
import { UserMaterial, validateAndGetLinkFromUserMaterial } from '../../../api/user-material';

export type Material = UserMaterial | Medialink;

export function isMedialink(material: Material): material is Medialink {
  return 'kind' in material;
}

export function getMaterialLink(material: Material): string | undefined {
  return isMedialink(material)
    ? validateAndGetLinkFromMedialink(material)
    : validateAndGetLinkFromUserMaterial(material);
}
